<template>
  <div class="row">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <h4 class="title">
            <span>Pending VOD sets</span>
          </h4>
          <div class="row">
            <div class="col-md-12">
              <vue-dropzone ref="myVueDropzone" id="dropzone" class="card placeholder" :class="{uploading: vodsetUploading}" :options="dropzoneOptions" :useCustomSlot="true" @vdropzone-file-added="sendingFile">
                <div class="card-content">
                  <h3 v-if="!vodsetUploading">Drop file here to create a VOD set.</h3>
                  <div class="w-100" v-else>
                    <div class="progress m-0">
                      <div class="progress-bar progress-bar-success" role="progressbar" :style="{width: vodsetUploadProgress+'%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </div>
              </vue-dropzone>
            </div>
          </div>
          <div class="row">
            <VodSetCard v-for="vodset in vodsetsPending" :vodset="vodset" :key="vodset.id" @move-set="updatePositions($event)" class="col-md-12"/>
          </div>
        </div>

        <div class="col-md-8">
          <h4 class="title">
            <span>Processed VOD sets</span>
          </h4>
          <div class="row">
            <VodSetCard class="col-md-6" v-for="vodset in vodsetsProcessed" :vodset="vodset" :key="vodset.id"/>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import {mapGetters, mapActions} from 'vuex'
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VodSetCard from "./List/VodSetCard";

export default {
  components: {VodSetCard, vueDropzone},
  async mounted () {
    await this.vodsetFetchList();
  },
  data: function () {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: {"My-Awesome-Header": "header value"},
        autoProcessQueue: false,
        previewsContainer: false,
      }
    }
  },
  computed: {
    ...mapGetters(['vodsetUploading', 'vodsetUploadProgress', 'vodsetsAll']),
    vodsetsPending: function () {
      return this.vodsetsAll
        .filter(vodset => vodset.status === 1)
        .sort((s1, s2) => s2.priority - s1.priority)
    },
    vodsetsProcessed: function () {
      return this.vodsetsAll.filter(vodset => vodset.status !== 1);
    }
  },
  methods: {
    ...mapActions(['vodsetCreate', 'vodsetFetchList', 'vodsetUpdatePositions']),
    updatePositions: function (e) {
      let positions = {};
      let count = this.vodsetsPending.length;
      this.vodsetsPending.forEach((item, key) => positions[count - key] = item.id)
      let indexIncrement = e.direction === 'up' ? 1 : -1;
      let itemIndex = Object.keys(positions).find(key => positions[key] === e.id);
      let switchIndex = parseInt(itemIndex) + indexIncrement;
      if (positions[switchIndex]) {
        positions[itemIndex] = positions[switchIndex];
        positions[switchIndex] = e.id;
      }
      this.vodsetUpdatePositions(positions);
    },
    sendingFile: function (file) {
      console.log(file)
      this.vodsetCreate(file);
    },
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/VodSets/List.vue